import React from "react";
import { toast } from "sonner";
import { Share2 } from "lucide-react";
import { cn, whatsappShareUrl } from "../lib/api";

/** Sign-off used at the end of every message Cricso shares on WhatsApp. */
export const SIGN_OFF = ["", "Thanks,", "Cricso", "Powered by HMT Technologies"];

/**
 * Opens WhatsApp with a pre-filled message built by getText(). The text is also copied,
 * so it can be pasted if the WhatsApp client drops it (or a popup blocker stops the window).
 */
export default function WhatsAppShareButton({ getText, label = "Share on WhatsApp", className, "data-testid": testid }) {
  const share = async (e) => {
    e.preventDefault();
    const text = getText();
    const win = window.open(whatsappShareUrl(text), "_blank");
    const blocked = !win || win.closed || typeof win.closed === "undefined";
    try {
      await navigator.clipboard?.writeText(text);
      if (blocked) toast.success("WhatsApp didn't open — message copied, paste it in your group");
    } catch {
      if (blocked) toast.error("Couldn't open WhatsApp");
    }
  };
  return (
    <button
      type="button"
      onClick={share}
      className={cn(
        "w-full h-11 rounded-2xl bg-[#25D366] hover:bg-[#20BD5A] text-white text-sm font-semibold flex items-center justify-center gap-2 btn-press",
        className,
      )}
      data-testid={testid}
    >
      <Share2 size={16} /> {label}
    </button>
  );
}
